<style>
.vue-dropzone .dz-preview .dz-details {
  background-color: #2a579a;
}
#addRasterModal .v--modal-box.v--modal {
  min-width: 580px !important;
  min-height: 300px !important;
}
#addRasterModal .modal__content {
  overflow-y: auto !important;
}
#addRasterModal .dropzone .dz-preview {
  margin: 0;
}
#addRasterModal .v-text-field__slot input,
#addRasterModal div.v-input__slot > label {
  font-size: 12px;
}
#addRasterModal div.v-input__slot > label {
  color: #000000;
}
#addRasterModal div.v-input__slot > div {
  margin-right: 0;
}
#addRasterModal div.v-input__slot > div > i {
  font-size: 18px;
}
#addRasterModal #addGeoserverBtn,
#addRasterModal div.v-input__slot > div > .v-input--selection-controls__ripple {
  display: none;
}
#addRasterModal
  div.v-input.v-input--selection-controls.v-input--checkbox.theme--light {
  max-height: 24px;
}
#add-raster-dropzone > div.dz-preview.dz-file-preview {
  min-height: 120px;
  height: 120px;
}
/* #addRasterModal .modal__footer, */
#add-raster-dropzone
  > div.dz-preview.dz-file-preview
  > div.dz-details
  > div.dz-size,
#add-raster-dropzone > div.dz-preview.dz-file-preview > div.dz-progress,
#add-raster-dropzone > div.dz-preview.dz-file-preview > a {
  display: none;
}
#add-raster-dropzone > div.dz-preview.dz-file-preview > div.dz-details {
  padding: 20px;
}
#add-raster-dropzone {
  min-height: 165px;
  height: 165px;
  display: flex;
  justify-content: center;
}
#delete-raster-container {
  display: flex;
  justify-content: space-between;
}
#add-raster-dropzone > div {
  margin: 0 !important;
}
.rasterInactive {
  color: lightgrey !important;
  pointer-events: none;
}
.rasterInactive label{
  color: lightgrey !important;
}
#progressContainer {
  text-align: center;
  margin-top: 30px;
}
</style>

<template>
  <div class="wrapper">
    <Modal
      modalName="addRasterModal"
      title="Dodawanie nowego rastra"
      :buttons="['addGeoserver']"
      @addGeoserver="addRasterToGeoserver"
      @closed="clearModal"
      @opened="clearModal"
      :addingRaster="addingRaster"
      :addRasterStep="addRasterStep"
      :addRasterDescription="addRasterDescription"
    >
      <div>
        <v-layout wrap align-center>
          <v-flex xs5>
            <vue-dropzone
              id="add-raster-dropzone"
              :options="dropOptions"
              :useCustomSlot="true"
              @vdropzone-sending="sendingEvent"
              @vdropzone-file-added="rasterAdded"
              @vdropzone-success="sendingCompleted"
              @vdropzone-error="failed"
              ref="rasterDropzone"
            >
              <div class="dropzone-custom-content">
                <h3
                  class="dropzone-custom-title font--primary"
                  style="color:rgb(42,87,154)"
                >Przeciągnij raster do wysłania</h3>
                <div class="subtitle font--primary">lub kliknij i wybierz je go swojego komputera</div>
              </div>
            </vue-dropzone>
          </v-flex>
          <v-spacer/>
          <v-flex xs6>
            <p class="font--primary">Podaj tytuł rastra</p>
            <v-text-field
              v-model="rasterTitle"
              :class="{ rasterInactive: !isFileAdded }"
              placeholder="Tutaj wpisz tytuł rastra"
              id="abstractName"
              :readonly="!!rasterID"
              height="16"
            ></v-text-field>
            <div id="delete-raster-container" :class="{ rasterInactive: !isFileAdded }">
              <p class="font--primary">Usuń wybrany raster / wyczyść</p>
              <v-icon @click="deleteRasterFromModal" small title="Usuń raster">delete</v-icon>
            </div>
            <div id="delete-raster-container" :class="{ rasterInactive: !isFileAdded || !!rasterID }">
              <p class="font--primary">Zapisz raster w aplikacji</p>
              <v-icon @click="addRasterToApp" small title="Zapisz raster">save</v-icon>
            </div>
            
            <v-checkbox 
              label="Raster użytkownika" 
              color="#2a579a" 
              :class="{ rasterInactive: !isFileAdded }"
              v-model="isRasterPrivate" 
              :readonly="!!rasterID"
              ></v-checkbox>
            
            <template v-if="rasterID">
              <br/>
              <p class="font--primary">
                Aktualny SRS
                <v-icon
                  small
                  title="Poniżej widać rozpoznany SRS. Przed zatwierdzeniem dodania rastra możesz zmienić tę wartość."
                >help</v-icon>
              </p>
              <v-text-field  v-model="rasterSRID" id="rasterSRID" required height="16"></v-text-field>
            </template>
          </v-flex>       
        </v-layout>
        <v-layout v-if="isLoading" id="progressContainer" wrap align-center>
          <v-flex xs12>
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-flex>
        </v-layout>
      </div>
    </Modal>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal,
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      dropOptions: {
        url: `${this.$store.getters.getApiURL}/geoserver_api/raster?token=${
          this.$store.getters.getToken
        }`,
        autoProcessQueue: false,
        addRemoveLinks: true,
        maxFiles: 1,
        maxFileSize: 1024,
        maxThumbnailFilesize: 0,
        language: {
          dictDefaultMessage:
            "Drop a PDF file here, or click to select a file to upload."
        }
      },
      rasterTitle: undefined,
      rasterSRID: undefined,
      rasterID: undefined,
      rasterExist: false,
      isFileAdded: false,
      isFileSent: false,
      isLoading: false,
      isRasterPrivate: false,
      addingRaster: true,
      addRasterStep: 1,
      fileSize: 0,
      addRasterDescription: "Dodawanie rastra do aplikacji"
    };
  },
  watch: {
  },
  methods: {
    failed(file, data, xhr) {      
      if (xhr && xhr.status === 409) {
        this.$root.$emit("showSnackbar", "error", data.message);
        this.isLoading = false;
        file.status = "queued";
        this.setDropzoneMessage(data.message);
      } else {
        this.setDropzoneMessage();
      }
    },
    sendingEvent(file, xhr, formData) {
      if (file.type !== "image/tiff") {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Podaj prawidłowy plik rastrowy"
        );
        this.isLoading = false;
        return;
      }
      formData.append("filename", file.name);
      formData.append("abstract", this.rasterTitle);
      formData.append("public", !this.isRasterPrivate);
    },
    sendingCompleted(file, response) {
      if (response.rasters_index.exists) {
        this.$root.$emit("showSnackbar", "orange", "Taki raster jest już dodany");
        this.rasterExist = true;
        this.isLoading = false;
        this.setDropzoneMessage("Taki raster jest już dodany");
        return;
      }
      if (response.rasters_index.srid === 9001) {
        this.$root.$emit("showSnackbar", "orange", "Nie rozpoznano EPSG");
      } else {
        this.rasterSRID = response.rasters_index.srid;
      }
      this.rasterID = response.rasters_index.id;
      if (response.rasters_index.extent) {
        this.rasterExtent = [
          response.rasters_index.extent.xmin,
          response.rasters_index.extent.ymin,
          response.rasters_index.extent.xmax,
          response.rasters_index.extent.ymax
        ];
      } else {
        this.rasterExtent = [];
      }
      this.isLoading = false;
      this.addRasterStep = 2;
      this.addRasterDescription = "Dodawanie rastra do GeoServera";
      document.querySelector("#addRasterModal #addGeoserverBtn").style.display = "block";
    },
    rasterAdded(file) {
      this.fileSize = file.size / 1000000;
      this.rasterTitle = file.name;
      this.isFileAdded = true;
    },
    deleteRasterFromModal() {
      if (this.rasterID) {
        alert(`Usunięto raster ${this.rasterID} - ${this.rasterTitle}`);
        this.$store.dispatch("deleteRaster", this.rasterID);
      }
      this.clearModal();
      this.isFileAdded = false;
      this.$refs.rasterDropzone.removeAllFiles();
    },
    addRasterToApp() {
      const self = this;
      if (this.fileSize > 15) {
        self.$modal.show("dialog", {
          title: "Dodawanie dużego pliku rastrowego",
          text: `Próbujesz dodać duży plik rastrowy (${self.fileSize.toFixed(
            2
          )} MB), którego upload może zająć dużo czasu. Czy na pewno chcesz kontynuować?`,
          buttons: [
            {
              title: "NIE",
              handler: () => {
                self.clearModal();
                self.$emit("confDialogOpened", false);
                self.$modal.hide("dialog");
                return;
              }
            },
            {
              title: "TAK",
              default: true,
              handler: () => {
                self.processUpload();
              }
            }
          ]
        });
      } else {
        self.processUpload();
      }
    },
    processUpload() {
      this.isLoading = true;

      let abstractNamVal = this.rasterTitle;
      if (!this.isFileAdded) {
        this.$root.$emit("showSnackbar", "red", "Nie wybrano rastra");
        return;
      } else {
        if (abstractNamVal !== "") {
          this.rasterTitle = abstractNamVal;
        }
        this.$refs.rasterDropzone.processQueue();
      }
      this.$emit("confDialogOpened", false);
      this.$modal.hide("dialog");
    },
    addRasterToGeoserver() {
      const self = this;
      if (self.rasterID === "") {
        self.$root.$emit("showSnackbar", "red", "Podaj SRID dla rastra");
        return;
      }
      let payload = {
        id: self.rasterID,
        //public: !this.isRasterPrivate,
        //abstract: this.rasterTitle,
        srid: parseInt(self.rasterSRID)
      };
      this.$store.dispatch("addGeoserverRaster", payload).then(r => {
        if (r) {
          self.$root.$emit(
            "showSnackbar",
            "success",
            "Dodano raster do geoservera"
          );
          self.$root.$emit(
            "addRasterLayer",
            r.coverage_name, //id
            r.url, //url
            !self.isRasterPrivate, //public
            self.rasterTitle, //name
            self.rasterID, //geoserwer_id
            self.rasterExtent, //extent
          );
          self.isFileSent = true;
          
          //this.$modal.hide("addRasterModal");
          self.clearModal();
          self.$refs.rasterDropzone.removeAllFiles();
        } else {
          self.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas dodawania rastra do geoservera wystąpił błąd"
          );
        }
      });
    },
    clearModal() {
      if (!this.isFileSent) {
        if (this.rasterID) {
          this.$store.dispatch("deleteRaster", this.rasterID);
        }
      }
      this.rasterTitle = undefined;
      this.rasterID = undefined;
      this.rasterSRID = undefined;
      this.rasterExtent = [];
      this.rasterExist = false;

      this.isFileAdded = false;
      this.isLoading = false;
      this.isRasterPrivate = false;
      this.isFileSent = false;

      this.fileSize = 0;
      this.addRasterStep = 1;
      this.addRasterDescription = "Dodawanie rastra do aplikacji";
      if (document.querySelector("#addRasterModal #addGeoserverBtn").style) {
        document.querySelector(
          "#addRasterModal #addGeoserverBtn"
        ).style.display = "none";
      }
    },
    setDropzoneMessage(message = 'Bład') {
      if (
          document
            .querySelector("div.dz-error-message > span")
            .hasAttribute("data-dz-errormessage")
        ) {
          document.querySelector("div.dz-error-message > span").innerHTML = message;
        }   
    }
  },
  created() {
    //console.log(this);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/start/modals/AddRaster.vue